module.exports = __webpack_public_path__ + "img/guide-05.1b478bbe.jpg";